import React from "react";
import { Link } from "react-router-dom";

export default function EventComponent(props) {
  const { event, onShowModal, type, path } = props;
  return (
    <div className="col-lg-4 col-md-6">
      <div className="single-service">
        {event?.event_logo && (
          <div className="text-center">
            <img src={path + event?.event_logo} height="120px" />
          </div>
        )}
        <h4>{event?.title}</h4>
        <h6>{event?.facilitated_by}</h6>
        <p className="pt-20">
          <span>
            <i className="fa fa-calendar" /> &nbsp; {event?.start_date}
          </span>
          <br />
          <span>
            <i className="fa fa-clock-o" /> &nbsp; {event?.start_time}
          </span>
          <br />
          <span>
            <i className="fa fa-thumb-tack" /> &nbsp; {event?.location}
          </span>
          <br />
          <span>
            <i className="fa fa-user" /> &nbsp; For {event?.who_can_attend}
          </span>
          <br />
          <span>
            <i className="fa fa-book" /> &nbsp; EV-{event?.id}
          </span>
        </p>
        <hr />
        <Link
          onClick={() => onShowModal(event, type)}
          data-toggle="modal"
          data-target="#signup"
          className="genric-btn primary-border small signin"
        >
          Know more
        </Link>
        <Link to="" className="pull-right" style={{ fontSize: 22 }}>
          <i className="fa fa-share-alt" />
        </Link>
        <div className="clearfix" />
      </div>
    </div>
  );
}
